import styled, { css } from 'styled-components/macro';
import { ifProp, theme } from 'styled-tools';
import { isMobile } from 'react-device-detect';

interface InputWrapperProps {
  flexBasis?: string;
  isCheckbox?: boolean;
  inline?: boolean;
  flexEnd?: boolean;
  isFilter?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  font-size: ${(isMobile ? '1rem' : 'inherit')};
  position: relative;

  && {
    flex-basis: ${props => (props.flexBasis ? props.flexBasis : '')};

    ${props => (!props.isFilter ? (css`
      margin-bottom: 1rem;
    `) : '')}

    ${ifProp('flexEnd', css`
      display: flex;
      align-items: flex-end;
    `)}
  }

  label {
    font-size: ${(isMobile ? '1.05rem' : 'inherit')};
    font-weight: ${props => (props.isFilter ? 'normal' : 'bold')};
    display: block;

    ${ifProp('isCheckbox', css`
      display: inline-block;
    `)}

    ${ifProp('inline', css`
      display: flex;
      align-items: center;
    `)}
  }

  input {
    padding: 0.5rem;
    color: ${theme('colors.darkBlue')};
    font-family: inherit;
    font-size: ${(isMobile ? '1rem' : 'inherit')};
    font-weight: bold;
    border: solid 1px ${theme('colors.lightGrey')};
    border-radius: 4px;
    width: 100%;

    ${props => (props.isCheckbox || props.inline ? (css`
      width: unset;
    `) : '')}

    ${props => (props.isCheckbox && !props.isFilter ? (css`
      margin-left: 1rem;
    `) : '')}
  }

  textarea {
    font-family: inherit;
    font-size: ${(isMobile ? '1rem' : 'inherit')};
  }
`;
